import {
  faGlobe,
  faUserShield,
  faBuildingUser,
  faUsersGear,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons"

const linksUrl = {
  login: "/",
  
  client: {
    clientMaster: "/client-master",
    createEntry: "/client-master/entry",
    clientSubsciption:"/client-subscription"
   
  },
  user: {
    userMaster: "/user-master",
    createEntry: "/user-master/create-entry",
   
  },
  
}

const apiRoute = {
  clientMaster: {
    addUpdate: "/client/add-update",
    getEntryData: "/client",
    checkClientCode:"/client/chk-client-code",
    deleteEntry:"/client/delete-entry"
  },
  userMaster: {
    addUpdate: "/user/add-update",
    getEntryData: "/user",
    fetchLogin:"/user/login",
    deleteEntry:"/user/delete-entry"
  },
   clientSubscription: {
    addUpdate: "/client-subscription/add-update",
    getEntryData: "/client-subscription",
    deleteEntry:"/client-subscription/delete-entry",
    getClientList:"/client-subscription/client-list"
  },
 
}

const stateEnum = {
  clientMaster: "clientMaster",
  userMaster: "userMaster",
  auth: "auth",
}

const sideNavLinks = [
  {
    name: "Client Master",
    icon: faBuildingUser,
    url: linksUrl.client.clientMaster,
  },
 
  {
    name: "User Master",
    icon: faUserCheck,
    url: linksUrl.user.userMaster,
  },
  {
    name: "Client Subsciption",
    icon: faUsersGear,
    url: linksUrl.client.clientSubsciption,
  },
] 

export { linksUrl, apiRoute, stateEnum, sideNavLinks }
